export default [
  'userService',
  'adSegmentsService',
  function (userService, adSegmentsService) {
    this.setSegmentVisible = adSegmentsService.setSegmentVisible;
    this.isSegmentHidden = adSegmentsService.isSegmentHidden;

    this.getUserBalance = () => userService.user.balance;

    this.getAgencyBalance = () => userService.user.agencyBalance;

    this.isSubAgent = () => userService.user.isSubAgent;

    this.getSubAgentMoneySource = () => userService.user.moneySource;
  },
];
